import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api";
import type { AllianceUptimeList, UptimeSeries } from "../../types/uptime";

interface UptimeState {
  apiSeries: UptimeSeries | null;
  allianceList: AllianceUptimeList | null;
  loading: boolean;
  error: string | null;
}

const initialState: UptimeState = {
  apiSeries: null,
  allianceList: null,
  loading: false,
  error: null,
};

export const fetchUptimeDashboard = createAsyncThunk(
  "uptime/fetchDashboard",
  async () => {
    const [apiSeries, allianceList] = await Promise.all([
      api.getApiUptime() as Promise<UptimeSeries>,
      api.getAllianceUptimeList() as Promise<AllianceUptimeList>,
    ]);
    return { apiSeries, allianceList };
  },
);

const uptimeSlice = createSlice({
  name: "uptime",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUptimeDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUptimeDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.apiSeries = action.payload.apiSeries;
        state.allianceList = action.payload.allianceList;
      })
      .addCase(fetchUptimeDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Greška pri dohvaćanju statusa dostupnosti";
      });
  },
});

export const uptimeReducer = uptimeSlice.reducer;
